import { render, staticRenderFns } from "./release-announcement.vue?vue&type=template&id=84d092bc&scoped=true&"
import script from "./release-announcement.vue?vue&type=script&lang=js&"
export * from "./release-announcement.vue?vue&type=script&lang=js&"
import style0 from "./release-announcement.vue?vue&type=style&index=0&id=84d092bc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d092bc",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84d092bc')) {
      api.createRecord('84d092bc', component.options)
    } else {
      api.reload('84d092bc', component.options)
    }
    module.hot.accept("./release-announcement.vue?vue&type=template&id=84d092bc&scoped=true&", function () {
      api.rerender('84d092bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/global/modal/release-announcement/release-announcement.vue"
export default component.exports